<template>
  <div>
    <b-table striped
             small
             hover
             thead-class="condensed_cc"
             tbody-class="condensed_cc"
             :items="items"
             :fields="fieldsData"
             v-model="visibleRows"
    ><!-- could also be a footer field slot instead -->
      <template v-slot:foot="data">
        <span class="text-danger">text</span>
      </template>
    </b-table>
    <p>
      <download-excel
        class   = "btn btn-secondary"
        :fields="xlsFieldsCat"
        :data="byCat"
        :worksheet = "workSheetCat"
        :name = "fileNameCat">
        Экспорт в Excel Форма №2
      </download-excel>
      <download-excel
        class   = "btn btn-secondary"
        :fields="xlsFields"
        :data="visibleRows"
        :worksheet = "workSheet"
        :name = "fileName">
        Экспорт в Excel Форма №3
      </download-excel>
    </p>
  </div>
</template>

<script>
export default {
  name: 'LegendTable',
  props: ['items', 'byCat'],
  data () {
    return {
      visibleRows: [],
      xlsFieldsCat: {
        'Муниципальный округ': 'reg_name',
        'Численность граждан, воспользовавшихся услугами ТК': 'c1',
        'Инвалиды по слуху': 'c2',
        'Лица старше 80 лет': 'c3'
      },
      xlsFields: {
        'Район': 'reg_name',
        'Консультации о работе ЛПУ, аптек, по здоровью': 'c1',
        'Вызов скорой медицинской помощи': 'c2',
        'Вопросы связанные с коммунальными службами': 'c3',
        'Вопросы социального характера': 'c4',
        'Плановая консультация по востребованным услугам (Проверочный звонок)': 'c5',
        'Консультация по вопросам оказания помощи гражданам с когнитивными нарушениями': 'c6',
        'Оказание консультативной помощи пожилым людям, подвергшимся жестокому обращению': 'c7',
        'Технический вопрос (устройство ТК)': 'c8',
        'Случайное нажатие на кноаку вызова ТК': 'c9',
        'Вызов Экстренных служб полиции и МЧС': 'c10',
        'Вызов участкового врача': 'c11',
        'Запись к врачу': 'c12',
        'Итого обработанных звонков': 'c13'
      },
      fieldsData: [
        {
          label: 'Район',
          key: 'reg_name',
          sortable: true
        },
        {
          label: 'Консультации о работе ЛПУ, аптек, по здоровью',
          key: 'c1',
          sortable: true
        },
        {
          label: 'Вызов скорой медицинской помощи',
          key: 'c2',
          sortable: true
        },
        {
          label: 'Вопросы связанные с коммунальными службами',
          key: 'c3',
          sortable: true
        },
        {
          label: 'Вопросы социального характера',
          key: 'c4',
          sortable: true
        },
        {
          label: 'Плановая консультация по востребованным услугам (Проверочный звонок)',
          key: 'c5',
          sortable: true
        },
        {
          label: 'Консультация по вопросам оказания помощи гражданам с когнитивными нарушениями',
          key: 'c6',
          sortable: true
        },
        {
          label: 'Оказание консультативной помощи пожилым людям, подвергшимся жестокому обращению',
          key: 'c7',
          sortable: true
        },
        {
          label: 'Технический вопрос (устройство ТК)',
          key: 'c8',
          sortable: true
        },
        {
          label: 'Случайное нажатие на кноаку вызова ТК',
          key: 'c9',
          sortable: true
        },
        {
          label: 'Вызов Экстренных служб полиции и МЧС',
          key: 'c10',
          sortable: true
        },
        {
          label: 'Вызов участкового врача',
          key: 'c11',
          sortable: true
        },
        {
          label: 'Запись к врачу',
          key: 'c12',
          sortable: true
        },
        {
          label: 'Итого обработанных звонков',
          key: 'c13',
          sortable: true
        }
      ]}
  },
  created () {
    console.log(this.fieldsData)
    console.log(this.items)
  },
  mounted () {
    console.log(this.fieldsData)
    console.log(this.items)
  },
  computed: {
    workSheet () {
      return 'Форма №3 Сводная таблица ' + localStorage.getItem('dateFrom') + ' - ' + localStorage.getItem('dateTo')
    },
    fileName () {
      return 'Форма №3Сводная таблица ' + localStorage.getItem('dateFrom') + ' - ' + localStorage.getItem('dateTo') + '.xls'
    },
    workSheetCat () {
      return 'Форма №2 Отчет в разрезе категорий ' + localStorage.getItem('dateFrom') + ' - ' + localStorage.getItem('dateTo')
    },
    fileNameCat () {
      return 'Форма №2 Отчет в разрезе категорий ' + localStorage.getItem('dateFrom') + ' - ' + localStorage.getItem('dateTo') + '.xls'
    },
    total_C1 () {
      return this.visibleRows.reduce((accum, item) => {
        // Assuming expenses is the field you want to total up
        return accum + parseFloat(item.c1)
      }, 0)
    }
  }
}
</script>

<style>
  .condensed_cc {
    font-size: 10px;
  }

  .thead {
    font-size: 5px;
  }

</style>



// WEBPACK FOOTER //
// src/components/LegendTable.vue